import React from "react";
import { H1 } from "../Headers";
import styled from "styled-components";
import QueryString from "query-string";
import ContactAddForm from "../contacts/ContactAddForm";
import { withRouter, RouteComponentProps } from "react-router";
import { Grid, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const Container = styled.div`
  max-width: 800px;
  margin: 3em auto;
`;

const Setting = styled(Grid)`
  display: flex;
  margin: 0 1em;
  align-items: center;

  & a {
    text-decoration: none;
  }
`;

const SettingButton = styled(Button)`
  height: 56px;
`;

const ActionSettingsGrid = styled(Grid)`
  display: flex;
  direction: row;
  justify-content: flex-end;
  align-items: stretch;
`;

const EditContacts = (props: RouteComponentProps) => {
  const {
    location: { search },
  } = props;

  const { returnUrl } = QueryString.parse(search);

  return (
    <Container>
      <ActionSettingsGrid item xs={12}>
        <Setting item xs={12}>
          <Link to="/users/list">
            <SettingButton variant="outlined" color="primary" size="large" startIcon={<ArrowBackIcon />}>
              Back
            </SettingButton>
          </Link>
        </Setting>
      </ActionSettingsGrid>
      <H1>Edit User</H1>
      <ContactAddForm returnUrl={returnUrl as string} />
    </Container>
  );
};

export default withRouter(EditContacts);
